import {Box, Menu, MenuItem, Tooltip} from '@mui/material'
import {Button} from '@viptech/react-components'
import {useState} from 'react'
import {ValidateUserPermissions} from 'src/common/utils/ValidatePermissions'
import actionsObject from 'src/images/actionsObject.svg'
import Delete from 'src/images/deleteIconBlack.svg'
import IconEditUser from 'src/images/iconEditUser.svg'
import createStyleSheet from 'src/utilities/createStyleSheet'

type Props = {
  onEdit: () => void
  onDelete: () => void
}

export function AlarmCenterZoneRowOption({onEdit, onDelete}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const canUpdate = ValidateUserPermissions('alarm-centers:update')
  const canDelete = ValidateUserPermissions('alarm-centers:delete')

  return (
    <>
      <Tooltip title='Opções' placement='top'>
        <Button
          variant='outlined'
          color='transparent'
          hoverColor='transparent'
          height='26px'
          onClick={(event) => {
            event.stopPropagation()
            setAnchorEl(event.currentTarget)
          }}>
          <img src={actionsObject} alt='Menu logo' style={{width: 20, height: 20}} />
        </Button>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem
          sx={styles.menuInfos}
          disabled={!canUpdate}
          onClick={() => {
            setAnchorEl(null)
            onEdit()
          }}>
          <Box sx={{display: 'flex', gap: '10px', alignItems: 'center'}}>
            <img src={IconEditUser} alt='' style={{width: 16, height: 16}} />
            <Box sx={{fontFamily: 'Inter'}}>Editar</Box>
          </Box>
        </MenuItem>
        <MenuItem
          sx={styles.menuInfos}
          disabled={!canDelete}
          onClick={() => {
            setAnchorEl(null)
            onDelete()
          }}>
          <Box sx={{display: 'flex', gap: '10px', alignItems: 'center'}}>
            <img src={Delete} alt='' style={{width: 16, height: 16}} />
            <Box sx={{fontFamily: 'Inter'}}>Excluir</Box>
          </Box>
        </MenuItem>
      </Menu>
    </>
  )
}

const styles = createStyleSheet({
  menuInfos: {
    fontSize: '12px',
    padding: '5px 12px',
  },
})
